import { useEffect, useMemo, useState } from "react";
import AppLayout from "../../../../shared/components/AppLayout";
import Button from "../../../../shared/components/Button";
import Spinner from "../../../../shared/components/Spinner";
import Toast from "../../../../shared/components/Toast";
import { siteTexts } from "../../../../shared/i18n/siteTexts";
import { confirmEmailChange } from "../../shared/services/authService";

function extractTokenFromHash() {
  const raw = String(window.location.hash || "");
  const queryPart = raw.includes("?") ? raw.slice(raw.indexOf("?") + 1) : "";
  const params = new URLSearchParams(queryPart);
  return String(params.get("token") || "").trim();
}

export default function ConfirmEmailPage() {
  const token = useMemo(() => extractTokenFromHash(), []);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    let active = true;
    const run = async () => {
      if (!token) {
        if (!active) return;
        setError(siteTexts.auth.confirmEmail.missingToken);
        setLoading(false);
        return;
      }
      try {
        const response = await confirmEmailChange(token);
        if (!active) return;
        setMessage(response?.message || siteTexts.auth.confirmEmail.success);
      } catch (err) {
        if (!active) return;
        setError(
          err instanceof Error ? err.message : siteTexts.auth.confirmEmail.error,
        );
      } finally {
        if (active) setLoading(false);
      }
    };
    void run();
    return () => {
      active = false;
    };
  }, [token]);

  return (
    <AppLayout title={siteTexts.auth.confirmEmail.title} subtitle="">
      {message && (
        <Toast
          message={message}
          variant="success"
          onClose={() => setMessage("")}
        />
      )}
      <div className="section-card">
        {loading ? (
          <p className="status-message">
            <Spinner label={siteTexts.auth.confirmEmail.loading} />
          </p>
        ) : error ? (
          <>
            <p className="status-message">{error}</p>
            <div className="user-profile-actions">
              <Button type="button" variant="pill" href="#/perfil">
                {siteTexts.common.backToProfile}
              </Button>
            </div>
          </>
        ) : (
          <>
            <div className="user-profile-actions">
              <Button type="button" variant="primary" href="#/perfil">
                {siteTexts.auth.confirmEmail.goToProfile}
              </Button>
            </div>
          </>
        )}
      </div>
    </AppLayout>
  );
}
